/* eslint-disable linebreak-style */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-filename-extension */
import React, { Component } from "react";
import { Helmet } from "react-helmet-async";

import Header1 from "parts/Header1";
import ProductsRubix from "partsproducts/ProductsRubix";
import Footer from "parts/Footer";
import Products from "parts/ProductsBlog1.js";
import { RubixCompute, Blog1 } from "../json/ProductsPageData.js";

export default class RubixComputePage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <Helmet>
          <title>Rubix Compute | Nube iO – Multi-Protocol Smart Edge Controller</title>
          <meta
            name="description"
            content="Control and connect building systems across every site with Rubix Compute, Nube iO's BACnet and LoRa®-ready edge controller for scalable automation."
          />
          <meta
            name="keywords"
            content="BACnet controller, IoT gateway, edge controller, smart building automation"
          />
          <link rel="canonical" href="https://nube-io.com/controllers/ " />
          <meta
            property="og:title"
            content="Rubix Compute | Nube iO – Multi-Protocol Smart Edge Controller"
          />
          <meta
            property="og:description"
            content="Control and connect building systems across every site with Rubix Compute, Nube iO's BACnet and LoRa®-ready edge controller for scalable automation."
          />
          <meta property="og:url" content="https://nube-io.com/controllers/" />
        </Helmet>
        <Header1 />
        <ProductsRubix data={RubixCompute} />
        <Products data={Blog1} />
        <Footer />
      </>
    );
  }
}
